export default "__VITE_ASSET__BTwSJudt__"